import { Subscribe } from '@/components/Subscribe'
import { PostLayoutDivider } from '@/components/PostLayoutDivider'

interface SubscribeFooterProps {
  title: string;
  convertKitFormID: string;
  includeTopDivider?: boolean;
}

export function SubscribeFooter({
  title,
  convertKitFormID,
  includeTopDivider = true,
}: SubscribeFooterProps) {
  return (
    <footer>
      <div className="relative">
        {includeTopDivider && <PostLayoutDivider />}
        <section className="relative py-4">
          <h2 className="text-xl font-semibold tracking-tight text-white">
            {title}&nbsp;
            <br />
            Subscribe to get notified.
          </h2>
          <Subscribe formId={convertKitFormID} />
        </section>
      </div>
    </footer>
  )
}
